import React from "react";
import SectionCard from "../SectionCard/SectionCard";
import { itensPoliticaPrivacidade } from "../../constants/PoliticaPrivacidadeItens";

function PoliticaPrivacidade() {
  const subtext1 = (
    <p>
      Nós já cuidamos de várias conquistas e pessoas da sua vida, né? Ainda
      temos mais um cuidado: <b> os seus dados pessoais. </b>
    </p>
  );

  const subtext2 = (
    <p>
      Tenha uma visão transparente e fácil de como nossa empresa protege suas
      informações, estabelecendo com você um elo de confiança e segurança.
    </p>
  );

  const subtext3 = (
    <p>
      Esse aviso se aplica à empresa CAIXA Consórcio e demonstra o alinhamento
      dessa empresa às exigências da Lei nº 13.709/2018, a Lei Geral de Proteção
      de Dados Pessoais (LGPD).
    </p>
  );
  return (
    <SectionCard
      id="Politicadeprivacidade"
      title="Aviso de Privacidade"
      subtext1={subtext1}
      subtext2={subtext2}
      subtext3={subtext3}
      itens={itensPoliticaPrivacidade}
      botaoMaisInfo
    />
  );
}

export default PoliticaPrivacidade;
